import style from '../Home.module.scss';
import {memo, useState, useCallback, useEffect} from "react";
import className from 'classnames/bind';
import {Col, Row} from "antd";
import dayjs from "dayjs";
import {apiError, handleRequest} from "~/utils";
import {dashboardApi} from "~/api";
import {
	ContentHeader,
	SidebarAccount,
	TrainingScheduleWeek,
	EvaluationFailedWidget,
	NoConsultationWidget,
	LowestPerformersWidget,
	DashboardPeriodFilter,
	CeoKpiCards,
	RevenueTrendChart,
	RevenueByGroupWidget,
	TopPerformersWidget,
	FinanceWidget,
} from "../componets";

const cn = className.bind(style);

function DashboardCEO({user, fullTime}) {

	const [period, setPeriod] = useState({period: 'month', time: dayjs().startOf('month').unix()});

	const [loading, setLoading] = useState(true);

	const [data, setData] = useState({
		overview       : null,
		trend          : null,
		revenueByGroup : [],
		topPerformers  : [],
		finance        : null,
	});

	const fetchData = useCallback(async (p) => {
		setLoading(true);

		const params = {period: p.period, time: p.time};

		const [
			overviewRes,
			trendRes,
			revenueByGroupRes,
			topPerformersRes,
			financeRes,
		] = await Promise.all([
			handleRequest(dashboardApi.ceoOverview(params)),
			handleRequest(dashboardApi.ceoRevenueTrend({time: p.time, months: 12})),
			handleRequest(dashboardApi.ceoRevenueByGroup(params)),
			handleRequest(dashboardApi.ceoTopPerformers({...params, limit: 5})),
			handleRequest(dashboardApi.ceoFinance(params)),
		]);

		const next = {};

		const [overviewErr, overviewData] = overviewRes;
		if (!apiError('', overviewErr, overviewData)) next.overview = overviewData.data;

		const [trendErr, trendData] = trendRes;
		if (!apiError('', trendErr, trendData)) next.trend = trendData.data;

		const [groupErr, groupData] = revenueByGroupRes;
		if (!apiError('', groupErr, groupData)) next.revenueByGroup = groupData.data || [];

		const [topErr, topData] = topPerformersRes;
		if (!apiError('', topErr, topData)) next.topPerformers = topData.data || [];

		const [financeErr, financeData] = financeRes;
		if (!apiError('', financeErr, financeData)) next.finance = financeData.data;

		setData((prev) => ({...prev, ...next}));
		setLoading(false);
	}, []);

	useEffect(() => {
		fetchData(period).then();
	}, [period, fetchData]);

	return (
		<div className={cn('dashboard')}>
			<div className={cn('sidebar')}>
				<SidebarAccount user={user} />
				<div style={{marginTop: 20}}>
					<FinanceWidget data={data.finance} loading={loading} />
				</div>
				<div style={{marginTop: 20}}>
					<NoConsultationWidget/>
				</div>
			</div>
			<div className={cn('content')}>
				<ContentHeader user={user} fullTime={fullTime} />

				<div style={{
					display: 'flex', justifyContent: 'space-between', alignItems: 'center',
					flexWrap: 'wrap', gap: 12, marginBottom: 16,
				}}>
					<h2 style={{fontSize: 18, fontWeight: 700, color: '#1e293b', margin: 0}}>Tổng quan công ty</h2>
					<DashboardPeriodFilter
						period={period.period}
						time={period.time}
						onChange={setPeriod}
					/>
				</div>

				<div style={{marginBottom: 20}}>
					<CeoKpiCards data={data.overview} />
				</div>

				<Row gutter={[20, 20]}>
					<Col xs={24} lg={16}>
						<RevenueTrendChart data={data.trend} loading={loading} />
						<Row gutter={[20, 20]} style={{marginTop: 20}}>
							<Col xs={24}>
								<TrainingScheduleWeek />
							</Col>
						</Row>
						<Row gutter={[20, 20]} style={{marginTop: 20}}>
							<Col xs={24} lg={12}>
								<EvaluationFailedWidget
									type="3day"
									title="Chưa đạt doanh số 3 ngày"
									icon="fa-light fa-gauge-low"
									gradient="linear-gradient(135deg, #b91c1c 0%, #dc2626 60%, #ef4444 100%)"
									fetcher={dashboardApi.ceoEvaluationFailed}
								/>
							</Col>
							<Col xs={24} lg={12}>
								<EvaluationFailedWidget
									type="7day"
									title="Chưa đạt doanh số 7 ngày"
									icon="fa-light fa-gauge"
									gradient="linear-gradient(135deg, #b45309 0%, #e47d0a 60%, #f59e0b 100%)"
									fetcher={dashboardApi.ceoEvaluationFailed}
								/>
							</Col>
						</Row>
					</Col>
					<Col xs={24} lg={8}>
						<RevenueByGroupWidget items={data.revenueByGroup} loading={loading} />
						<div style={{marginTop: 20}}>
							<TopPerformersWidget items={data.topPerformers} loading={loading} />
						</div>
					</Col>
				</Row>






			</div>
		</div>
	);
}

export default memo(DashboardCEO);
